export default __webpack_public_path__ + "static/media/logo-halloween.4dcf75a6.svg";